import React, { useState } from "react";
import { Section } from "./UI";
import { leadsService } from "../services/leadsService";
import { useToast } from "./Toast";
import { ExportDialog } from "./ExportDialog";
import { goToV2 } from "../utils/versionSwitch";

export function Menu({ startAdd, setView, role, leads, exportCsv }) {
  const [exporting, setExporting] = useState(false);
  const [showExportDialog, setShowExportDialog] = useState(false);
  const toast = useToast();

  const handleExportCSV = async (filters = {}) => {
    try {
      setExporting(true);
      console.log('Starting CSV export with filters:', filters);
      
      // Получаем данные экспорта (CSV загружен в S3)
      const exportData = await leadsService.exportCSV(filters);
      
      console.log('Export data received:', exportData);
      
      toast.success(`✅ Файл готов к скачиванию (${exportData.leads_count} лидов)`);
      toast.success(`⏰ Ссылка действительна ${exportData.expires_in_days} дней`);
      
      return exportData;
    } catch (error) {
      console.error('Ошибка экспорта CSV:', error);
      console.error('Error details:', error.message, error.stack);
      toast.error(`Ошибка экспорта: ${error.message}`);
      return null;
    } finally {
      setExporting(false);
    }
  };
  return (
    <>
      {/* Переход на новый дизайн (/v2/). Текущая версия остаётся здесь без изменений. */}
      <button
        onClick={goToV2}
        className="w-full flex items-center gap-3 p-4 rounded-2xl border border-blue-300 dark:border-blue-700 bg-blue-50 dark:bg-blue-900/25 hover:bg-blue-100 dark:hover:bg-blue-900/40 text-left transition-colors"
      >
        <span className="text-2xl">✨</span>
        <span className="flex-1 min-w-0">
          <span className="block font-medium text-blue-700 dark:text-blue-300">Новый дизайн</span>
          <span className="block text-xs text-blue-600/80 dark:text-blue-400/80">
            Beta — открыть на /v2/. Вернуться можно в любой момент
          </span>
        </span>
        <span className="text-blue-500 dark:text-blue-400">→</span>
      </button>

      <Section title="Быстрые действия">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <button onClick={startAdd} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
          <div className="text-2xl">➕</div>
          <div className="font-medium">Добавить</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Новый контакт с конфы</div>
        </button>
        <button onClick={() => setView("ai-scan")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
          <div className="text-2xl">🤖</div>
          <div className="font-medium">AI Сканер</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Добавить по визитке</div>
        </button>
        <button onClick={() => setView("list")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
          <div className="text-2xl">👤</div>
          <div className="font-medium">Мои лиды</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Просмотр и правки</div>
        </button>
        {(role === "admin" || role === "super_admin") && (
          <button onClick={() => setView("all-leads")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
            <div className="text-2xl">📋</div>
            <div className="font-medium">Все лиды</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">Админ-панель</div>
          </button>
        )}
        <button onClick={() => setView("help")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
          <div className="text-2xl">ℹ️</div>
          <div className="font-medium">Подсказка</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Гайд по полям</div>
        </button>
        {(role === "admin" || role === "super_admin") && (
          <>
            <button onClick={() => setShowExportDialog(true)} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors" disabled={exporting}>
              <div className="text-2xl">📤</div>
              <div className="font-medium">{exporting ? 'Экспорт...' : 'Экспорт CSV'}</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Все лиды</div>
            </button>
            <button onClick={() => setView("stats")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
              <div className="text-2xl">📊</div>
              <div className="font-medium">Статистика</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Аналитика</div>
            </button>
          </>
        )}
        {role === "super_admin" && (
          <>
            <button onClick={() => setView("users")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
              <div className="text-2xl">👥</div>
              <div className="font-medium">Пользователи</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Управление</div>
            </button>
            <button onClick={() => setView("events")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
              <div className="text-2xl">🎉</div>
              <div className="font-medium">Ивенты</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Управление</div>
            </button>
            <button onClick={() => setView("prompts")} className="p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors">
              <div className="text-2xl">🤖</div>
              <div className="font-medium">AI Промпты</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Настройка AI</div>
            </button>
          </>
        )}
      </div>
    </Section>
      
      {showExportDialog && (
        <ExportDialog
          onExport={handleExportCSV}
          onClose={() => setShowExportDialog(false)}
          exporting={exporting}
        />
      )}
    </>
  );
}
